import React, { FC, useCallback } from 'react';

import { scrollToTop, useTimeoutEffect } from 'Modules/ui2';
import { Text, Button, Label, linkAnchorClass } from 'Modules/ui2/components';

import FailureIcon from '../Icons/registrationFailure.sprite.svg';
import { DefaultComponentProps } from '../types';
import commonStyles from '../common.module.scss';


type FailureLiteProps = DefaultComponentProps & {
    error: string;
}

export const FailureINNLite: FC<FailureLiteProps> = ({ t, setStage }) => {
    useTimeoutEffect(scrollToTop, 100);
    return (
        <>
            <div className={commonStyles.resultLiteIcon}>
                <FailureIcon />
            </div>
            <Label component='h3' className={commonStyles.error} weight='demibold' textSize='21-24'>
                {t('failureINNLite.title')}
            </Label>
            <Text component='p' className={commonStyles.description} textSize='18'>
                {t('failureINNLite.description1', { linkClass: linkAnchorClass })}
            </Text>
            <Text component='p' className={commonStyles.description} textSize='18'>
                {t('failureINNLite.description2', { linkClass: linkAnchorClass })}
            </Text>
            <Button
                variant='normal'
                className={commonStyles.button}
                size='56'
                type='button'
                onClick={useCallback(
                    () => setStage('lead'),
                    [setStage],
                )}
            >
                {t('failureINNLite.button')}
            </Button>
        </>
    );
};
